import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// Hardcoded data
const courses = [
  {
    id: 1,
    title: 'Introduction to Phishing',
    description: 'Learn the basics of phishing attacks and how to identify them.',
    modules: 4,
    duration: '45 min',
    image: 'https://images.unsplash.com/photo-1593642702909-dec73df255d7',
    progress: 100,
    status: 'completed',
  },
  {
    id: 2,
    title: 'Email Security Fundamentals',
    description: 'Master the essentials of email security and protection against common threats.',
    modules: 5,
    duration: '1 hour',
    image: 'https://images.unsplash.com/photo-1583242210928-553ac5f079af',
    progress: 60,
    status: 'in-progress',
  },
  {
    id: 3,
    title: 'Advanced Phishing Techniques',
    description: 'Explore sophisticated phishing methods and advanced defense strategies.',
    modules: 6,
    duration: '1.5 hours',
    image: 'https://images.unsplash.com/photo-1563986768609-322da13575f3',
    progress: 0,
    status: 'not-started',
  },
  {
    id: 4,
    title: 'Social Engineering Defense',
    description: 'Understand social engineering tactics and develop effective countermeasures.',
    modules: 5,
    duration: '1 hour',
    image: 'https://images.unsplash.com/photo-1607799279861-4dd421887fb3',
    progress: 0,
    status: 'not-started',
  },
  {
    id: 5,
    title: 'Mobile Device Security',
    description: 'Learn how to protect your mobile devices from phishing and other threats.',
    modules: 3,
    duration: '30 min',
    image: 'https://images.unsplash.com/photo-1522199755839-a2bacb67c546',
    progress: 25,
    status: 'in-progress',
  },
];

const Courses = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  
  useEffect(() => {
    // Simulate data loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    
    return () => clearTimeout(timer);
  }, []);
  
  // Filter courses based on status
  const filteredCourses = filter === 'all' 
    ? courses 
    : courses.filter(course => course.status === filter);
  
  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-500"></div>
      </div>
    );
  }
  
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Available Courses
        </h1>
        <div className="flex space-x-2">
          <button 
            onClick={() => setFilter('all')}
            className={`btn ${filter === 'all' ? 'btn-primary' : 'btn-outline'}`}
          >
            All
          </button>
          <button 
            onClick={() => setFilter('in-progress')}
            className={`btn ${filter === 'in-progress' ? 'btn-primary' : 'btn-outline'}`}
          >
            In Progress
          </button>
          <button 
            onClick={() => setFilter('completed')}
            className={`btn ${filter === 'completed' ? 'btn-primary' : 'btn-outline'}`}
          >
            Completed
          </button>
          <button 
            onClick={() => setFilter('not-started')}
            className={`btn ${filter === 'not-started' ? 'btn-primary' : 'btn-outline'}`}
          >
            Not Started
          </button>
        </div>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredCourses.map(course => (
          <div key={course.id} className="card overflow-hidden flex flex-col">
            <div className="h-48 bg-gray-200 relative">
              <img 
                src={`${course.image}?w=600&h=400&auto=format&fit=crop`} 
                alt={course.title}
                className="w-full h-full object-cover"
              />
              {course.status === 'completed' && (
                <div className="absolute top-2 right-2 bg-green-500 text-white px-2 py-1 rounded-md text-xs font-medium">
                  Completed
                </div>
              )}
              {course.status === 'in-progress' && (
                <div className="absolute top-2 right-2 bg-blue-500 text-white px-2 py-1 rounded-md text-xs font-medium">
                  In Progress
                </div>
              )}
            </div>
            
            <div className="p-4 flex-grow">
              <h2 className="text-lg font-semibold mb-2">{course.title}</h2>
              <p className="text-gray-600 text-sm mb-4">{course.description}</p>
              
              <div className="flex justify-between text-sm text-gray-500 mb-4">
                <span>{course.modules} modules</span>
                <span>{course.duration}</span>
              </div>
              
              {course.progress > 0 && (
                <div className="mt-2">
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div 
                      className="bg-primary-600 h-2.5 rounded-full" 
                      style={{ width: `${course.progress}%` }}
                    ></div>
                  </div>
                  <div className="text-xs text-gray-500 mt-1 text-right">
                    {course.progress}% complete
                  </div>
                </div>
              )}
            </div>
            
            <div className="px-4 pb-4 mt-auto">
              <Link
                to={`/courses/${course.id}`}
                className="w-full btn btn-primary text-center block"
              >
                {course.status === 'not-started' 
                  ? 'Start Course' 
                  : course.status === 'completed' 
                    ? 'Review Course' 
                    : 'Continue Course'}
              </Link>
            </div>
          </div>
        ))}
      </div>
      
      {filteredCourses.length === 0 && (
        <div className="text-center py-12">
          <p className="text-gray-500">No courses found matching the selected filter.</p>
        </div>
      )}
    </div>
  );
};

export default Courses; 